export const environment = {
    production: false,
    ambiente: 'STAGING',
    cookieDomain: 'consultor-homolog.azurewebsites.net',
    api: 'https://geradorpropostashomolog.azurewebsites.net/',
    institutionalSite: 'https://gray-smoke-0c219ad0f.2.azurestaticapps.net',
    sistemaVO: 'https://voenerzeehomolog.azurewebsites.net/'
};